import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon, { TIconProps } from '../../icon';
import { TRightIcon } from '../types/cta.types';

const CTARightIcon: FC<TRightIcon> = (props) => {
  const { iconField, iconName, isSecondaryCTA = false } = props;
  const iconProps: TIconProps = {};

  if (iconField?.iconUrl) iconProps['iconField'] = iconField;
  if (iconName) iconProps['iconName'] = iconName;
  if (!iconName && !iconField?.iconUrl && isSecondaryCTA) iconProps['iconName'] = 'arrow-chevron-right';

  return (
    <div className="cta-arrow">
      <Icon {...iconProps} size={iconSize['dsk']} color={'primary'} />
    </div>
  );
};

export default CTARightIcon;
